export default "__VITE_ASSET__DxbeLYkA__"